export default {
  STATUS: {
    REQUEST_REQUIRED: 1,
    SUBMITTED_TO_WBCI: 2,
    SUBMITTED_TO_CLUB: 3,
    APPROVED: 4,
    DENIED: 5,
    CANCELLED: 6
  },
  ID: {
    1: "REQUEST_REQUIRED",
    2: "SUBMITTED_TO_WBCI",
    3: "SUBMITTED_TO_CLUB",
    4: "APPROVED",
    5: "DENIED",
    6: "CANCELLED"
  },
  DISPLAY_NAMES: {
    1: "Request Required",
    2: "Submitted to WBCI",
    3: "Submitted to Club",
    4: "Approved",
    5: "Denied",
    6: "Cancelled"
  }
};
